import { RFValue } from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;
